// Added by Sejune Oh on 2020-04-21
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react';
import {
    ListItemText as MaterialUIListItemText,
    ListItemTextProps as MaterialUIListItemTextProps
} from '@material-ui/core'

interface ListItemTextBaseProps { }
export type ListItemTextProps = Partial<MaterialUIListItemTextProps> & ListItemTextBaseProps

export const ListItemText: FC<ListItemTextProps> = ({ ...rest }) => {
    return <MaterialUIListItemText {...rest}></MaterialUIListItemText>
}
